import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ChatPanel } from './ChatPanel';
import './AiChat.css';

/**
 * AiChatTrigger — injects AI button into the EDS header next to notification.
 * Uses createPortal to render inside the existing header actions container.
 */
export const AiChatTrigger: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const inject = () => {
      // Find the notification trigger and insert our button before it
      const notifEl = document.querySelector('.notification-log-trigger');
      if (notifEl && notifEl.parentElement) {
        // Create a container div for our button that sits in the same flex row
        let container = document.getElementById('ai-chat-trigger-portal');
        if (!container) {
          container = document.createElement('div');
          container.id = 'ai-chat-trigger-portal';
          container.className = 'item'; // Same class as other header items
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          notifEl.parentElement.insertBefore(container, notifEl);
        }
        setPortalContainer(container);
      }
    };

    // Try multiple times since EDS header renders async
    inject();
    const t1 = setTimeout(inject, 500);
    const t2 = setTimeout(inject, 1500);
    const t3 = setTimeout(inject, 3000);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  const button = (
    <button
      className="ai-chat-trigger-btn"
      onClick={() => setVisible(!visible)}
      aria-label="Open AI Assistant"
      title="AI Assistant"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8 1L10 5.5L15 6.5L11.5 10L12.5 15L8 12.5L3.5 15L4.5 10L1 6.5L6 5.5L8 1Z" fill="white"/>
      </svg>
      <span>AI Chat</span>
    </button>
  );

  return (
    <>
      {portalContainer ? createPortal(button, portalContainer) : null}
      <ChatPanel visible={visible} onClose={() => setVisible(false)} />
    </>
  );
};
